import { render } from "./NewsletterUnsubscribe.vue?vue&type=template&id=d879ccee&scoped=true"
import script from "./NewsletterUnsubscribe.vue?vue&type=script&lang=js"
export * from "./NewsletterUnsubscribe.vue?vue&type=script&lang=js"

import "./NewsletterUnsubscribe.vue?vue&type=style&index=0&id=d879ccee&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/82161804/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d879ccee"]])

export default __exports__